export const SerialNoSearchPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">출고 Serial No 검색</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-info color2 w-170px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_download.png"} alt="" /> 엑셀 양식 다운로드</button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">검색어</label>
                            <select className="form-select w-150px">
                                <option>업체명</option>
                            </select>
                            <input type="text" className="form-control" placeholder="" />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">출고일</label>
                            <div className="frm_field input_date">
                                <input type="date" className="form-control" />
                                <span className="txt_range">~</span>
                                <input type="date" className="form-control me-0" />
                                <button className="btn btn-info btn_search">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="position-relative">

                <div className="content_wrap">
                    <div className="table_top">
                        <h6 className="table_stats">출고 Serial No 목록 (<span>23</span>건)</h6>
                        <div className="table_toolbar">
                            <button className="btn btn-outline-dark w-150px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt="" />엑셀 가져오기</button>
                        </div>
                    </div>

                    <div className="table_scroll">
                        <table className="table table-bordered my_table">
                            <colgroup>
                                <col style={{ width: "8.73%" }} />
                                <col style={{ width: "8.29%" }} />
                                <col style={{ width: "7.86%" }} />
                                <col style={{ width: "8.29%" }} />
                                <col style={{ width: "8.73%" }} />
                                <col style={{ width: "8.73%" }} />
                                <col style={{ width: "7.86%" }} />
                                <col style={{ width: "7.86%" }} />
                                <col style={{ width: "6.98%" }} />
                                <col style={{ width: "11.79%" }} />
                                <col style={{ width: "5.67%" }} />
                                <col style={{ width: "5.67%" }} />
                                <col />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>거래처 코드</th>
                                    <th>출고업체명</th>
                                    <th>규격</th>
                                    <th>SN(start1)</th>
                                    <th>SN(end1)</th>
                                    <th>SN(start2)</th>
                                    <th>SN(end2)</th>
                                    <th>SN(start3)</th>
                                    <th>SN(end3)</th>
                                    <th>출고일</th>
                                    <th>파일명</th>
                                    <th>QTY</th>
                                    <th>비고</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-end">000876</td>
                                    <td className="text-center">한주씨앤에스</td>
                                    <td className="text-center">6FA-00557</td>
                                    <td className="text-center">04537-010-002-767</td>
                                    <td className="text-center">04537-010-002-767</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end">2025-01-02</td>
                                    <td className="text-center">0101_(1)</td>
                                    <td className="text-center">1</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="text-end">000876</td>
                                    <td className="text-center">한주씨앤에스</td>
                                    <td className="text-center">6FA-00557</td>
                                    <td className="text-center">04537-010-002-767</td>
                                    <td className="text-center">04537-010-002-767</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end">2025-01-02</td>
                                    <td className="text-center">0101_(1)</td>
                                    <td className="text-center">1</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td className="text-end"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <div className="pagination-container">
                        <ul>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                    alt="First Page"
                                    className=""
                                />
                            </li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                    alt="Previous Page"
                                    className=""
                                />
                            </li>
                            <li className="active">1</li>
                            <li className="">2</li>
                            <li className="">3</li>
                            <li className="">4</li>
                            <li className="">5</li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                    alt="Next Page"
                                    className=""
                                />
                            </li>
                            <li className="pg_nav">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                    alt="Last Page"
                                    className=""
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}
